"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENCRYPTION_VERSION = void 0;
// Encryption used for zkCerts when being exported or passed from guardian to user
exports.ENCRYPTION_VERSION = 'x25519-xsalsa20-poly1305';
